export const DRAFT_AGENCY_CHAT_DEFAULT_PANEL_WIDTH = 400
export const DRAFT_AGENCY_CHAT_MIN_PANEL_WIDTH = 320
export const DRAFT_AGENCY_CHAT_MAX_PANEL_WIDTH = 600

export const DRAFT_AGENCY_CHAT_PANEL_CONSTRAINTS = {
  defaultWidth: DRAFT_AGENCY_CHAT_DEFAULT_PANEL_WIDTH,
  minWidth: DRAFT_AGENCY_CHAT_MIN_PANEL_WIDTH,
  maxWidth: DRAFT_AGENCY_CHAT_MAX_PANEL_WIDTH,
} as const
